import { useState } from 'react';

function americanToImplied(american) {
	const a = parseFloat(american);
	if (isNaN(a) || a === 0) return NaN;
	if (a > -100 && a < 100) return NaN;
	if (a > 0) return 100 / (a + 100);
	return Math.abs(a) / (Math.abs(a) + 100);
}

function impliedToAmerican(prob) {
	if (prob <= 0 || prob >= 1) return NaN;
	if (prob >= 0.5) return Math.round(-prob / (1 - prob) * 100);
	return Math.round((1 - prob) / prob * 100);
}

export const HoldCalculator = () => {
	const [oddsA, setOddsA] = useState('');
	const [oddsB, setOddsB] = useState('');

	const impliedA = americanToImplied(oddsA);
	const impliedB = americanToImplied(oddsB);
	const hasResults = !isNaN(impliedA) && !isNaN(impliedB) && impliedA > 0 && impliedB > 0;

	let results = null;
	if (hasResults) {
		const overround = (impliedA + impliedB);
		const holdPct = (overround - 1) * 100;
		const noVigA = impliedA / overround;
		const noVigB = impliedB / overround;
		const fairOddsA = impliedToAmerican(noVigA);
		const fairOddsB = impliedToAmerican(noVigB);

		results = {
			impliedA: impliedA * 100,
			impliedB: impliedB * 100,
			overround: overround * 100,
			holdPct,
			noVigA: noVigA * 100,
			noVigB: noVigB * 100,
			fairOddsA,
			fairOddsB,
		};
	}

	const handleReset = () => {
		setOddsA('');
		setOddsB('');
	};

	const formatAmerican = (odds) => {
		if (isNaN(odds)) return '—';
		return odds > 0 ? `+${odds}` : `${odds}`;
	};

	return (
		<div>
			<div className="calc-section">
				<h3 className="calc-section-title">Market Odds (American)</h3>
				<div className="calc-grid calc-grid-2">
					<div className="calc-input-group">
						<label className="calc-label">Side A Odds</label>
						<input
							className="calc-input"
							type="text"
							placeholder="-110"
							value={oddsA}
							onChange={(e) => setOddsA(e.target.value)}
						/>
					</div>
					<div className="calc-input-group">
						<label className="calc-label">Side B Odds</label>
						<input
							className="calc-input"
							type="text"
							placeholder="-110"
							value={oddsB}
							onChange={(e) => setOddsB(e.target.value)}
						/>
					</div>
				</div>
			</div>

			{results && (
				<div className="calc-results">
					<h4 className="calc-results-title">Hold/Vig Results</h4>
					<div className="calc-result-row">
						<span className="calc-result-label">Hold/Vig</span>
						<span className="calc-result-value negative">{results.holdPct.toFixed(2)}%</span>
					</div>
					<div className="calc-result-row">
						<span className="calc-result-label">Overround</span>
						<span className="calc-result-value">{results.overround.toFixed(2)}%</span>
					</div>
					<div className="calc-result-row">
						<span className="calc-result-label">Implied Prob A</span>
						<span className="calc-result-value">{results.impliedA.toFixed(2)}%</span>
					</div>
					<div className="calc-result-row">
						<span className="calc-result-label">Implied Prob B</span>
						<span className="calc-result-value">{results.impliedB.toFixed(2)}%</span>
					</div>
					<div className="calc-result-row">
						<span className="calc-result-label">No-Vig Prob A</span>
						<span className="calc-result-value highlight">{results.noVigA.toFixed(2)}%</span>
					</div>
					<div className="calc-result-row">
						<span className="calc-result-label">No-Vig Prob B</span>
						<span className="calc-result-value highlight">{results.noVigB.toFixed(2)}%</span>
					</div>
					<div className="calc-result-row">
						<span className="calc-result-label">Fair Odds A</span>
						<span className="calc-result-value">{formatAmerican(results.fairOddsA)}</span>
					</div>
					<div className="calc-result-row">
						<span className="calc-result-label">Fair Odds B</span>
						<span className="calc-result-value">{formatAmerican(results.fairOddsB)}</span>
					</div>
				</div>
			)}

			<button className="calc-reset-btn" onClick={handleReset}>Reset</button>
		</div>
	);
};
